import { AspectRatio, Box, Grid } from '@chakra-ui/react'
import { useSetRecoilState } from 'recoil'
import { ItList } from 'types/graphql'

import { lightboxImageModalState } from 'src/atoms/ui.atom'
import ItListImage from 'src/components/widgets/ItListImage/ItListImage'

const Reviews: React.FC<{
  itList: ItList
  locked: boolean
  isPreview: boolean
}> = ({ itList, locked, isPreview }) => {
  const setLightboxModalState = useSetRecoilState(lightboxImageModalState)
  if (!locked || !itList.reviews?.length) return null
  return (
    <Box mx={{ base: 4, lg: isPreview ? 4 : 24 }} id="it-list-item-reviews">
      <Box as="h4" className="thick" mt={12} mb={6}>
        Testimonials
      </Box>
      <Grid
        mt={4}
        gap={4}
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
      >
        {itList.reviews.map((review, index) => (
          <AspectRatio
            key={`EditItListPreview - Reviews - ${review.id}`}
            ratio={1 / 1}
          >
            <ItListImage
              htmlHeight={268}
              htmlWidth={268}
              filter="brightness(0.98)"
              src={review.coverUrl}
              alt={`ItList - Reviews - ${review.id}`}
              border={1}
              borderColor="sandstonePlus"
              borderRadius={{ base: 16, md: 12 }}
              data-testid={`reviews-testimonialImage-${index}`}
              onClick={() => {
                setLightboxModalState({
                  image: {
                    src: review.coverUrl,
                    alt: `Review and press image #${index}`,
                  },
                  isOpen: true,
                })
              }}
            />
          </AspectRatio>
        ))}
      </Grid>
    </Box>
  )
}

export default Reviews
